import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { getBooleanVal, getStringVal, toFloat } from "@dp/common";
import flatten from "lodash/flatten";

var Menu = /*#__PURE__*/function () {
  function Menu(config, axios) {
    _classCallCheck(this, Menu);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Menu, [{
    key: "getRecommentation",
    value: function () {
      var _getRecommentation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var _response$data, _response$data$succes, _response$data$succes2, response;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.post(this.config.postfix.RECOMMENDATION_LIST_API, request, {
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 3:
                response = _context.sent;
                return _context.abrupt("return", (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$succes = _response$data.successResponse) === null || _response$data$succes === void 0 ? void 0 : (_response$data$succes2 = _response$data$succes.content) === null || _response$data$succes2 === void 0 ? void 0 : _response$data$succes2.recEntitiesResults);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", null);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getRecommentation(_x) {
        return _getRecommentation.apply(this, arguments);
      }

      return getRecommentation;
    }()
  }, {
    key: "getFrequesntlyOrderedItem",
    value: function () {
      var _getFrequesntlyOrderedItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axios.get(this.config.postfix.FREQUENTLY_ORDERED_ITEM);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", null);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getFrequesntlyOrderedItem() {
        return _getFrequesntlyOrderedItem.apply(this, arguments);
      }

      return getFrequesntlyOrderedItem;
    }()
  }, {
    key: "getMenuItemDetail",
    value: function () {
      var _getMenuItemDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(restaurantId, menuItemId, orderType) {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.axios.get(this.config.postfix.MENU_ITEM_DETAILS, {
                  params: {
                    menuItemId: menuItemId,
                    restaurantId: restaurantId,
                    orderType: orderType
                  }
                });

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", response.data);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getMenuItemDetail(_x2, _x3, _x4) {
        return _getMenuItemDetail.apply(this, arguments);
      }

      return getMenuItemDetail;
    }()
  }, {
    key: "processMenuAPIResponse",
    value: function () {
      var _processMenuAPIResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(response, categoryId, restaurantNumber) {
        var _response$data2, _response$data2$succe;

        var menuCategoryList, subCategories;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                menuCategoryList = (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$succe = _response$data2.successResponse) === null || _response$data2$succe === void 0 ? void 0 : _response$data2$succe.menucategory;

                if (!(menuCategoryList && menuCategoryList.length > 0)) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 4;
                return this.parseMenuCategory(menuCategoryList, null, null, restaurantNumber);

              case 4:
                subCategories = _context4.sent;
                return _context4.abrupt("return", {
                  categoryId: categoryId,
                  subCategories: subCategories
                });

              case 8:
                return _context4.abrupt("return", {
                  categoryId: categoryId,
                  subCategories: []
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function processMenuAPIResponse(_x5, _x6, _x7) {
        return _processMenuAPIResponse.apply(this, arguments);
      }

      return processMenuAPIResponse;
    }()
  }, {
    key: "getMenu",
    value: function () {
      var _getMenu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(restaurantId, categoryId, restaurantNumber) {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.axios.get(this.config.postfix.CATEGORY_MENU_ITEMS, {
                  params: {
                    categoryId: categoryId,
                    conceptCode: this.config.getConceptCode(),
                    restaurantId: restaurantId
                  }
                });

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", this.processMenuAPIResponse(response, categoryId, restaurantNumber));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getMenu(_x8, _x9, _x10) {
        return _getMenu.apply(this, arguments);
      }

      return getMenu;
    }()
  }, {
    key: "getFavorites",
    value: function () {
      var _getFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _response$data3, _response$data3$succe;

        var response, favoritesList;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.axios.get(this.config.postfix.LIST_FAVORITES_API);

              case 2:
                response = _context6.sent;
                favoritesList = response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$succe = _response$data3.successResponse) === null || _response$data3$succe === void 0 ? void 0 : _response$data3$succe.favorites;

                if (!(favoritesList && favoritesList.length > 0)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return", {
                  favorites: favoritesList
                });

              case 8:
                return _context6.abrupt("return", {
                  favorites: []
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getFavorites() {
        return _getFavorites.apply(this, arguments);
      }

      return getFavorites;
    }()
  }, {
    key: "saveToFavorites",
    value: function () {
      var _saveToFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(productId) {
        var _response$data4;

        var response, successResponse;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.axios.post(this.config.postfix.SAVE_FAVORITES, {
                  productId: productId,
                  categoryId: "cat3920003",
                  // TODO Get the categoryId on the card clicked on.
                  togoNewFlow: true,
                  locale: "en_US"
                });

              case 2:
                response = _context7.sent;
                successResponse = response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.successResponse;

                if (!successResponse) {
                  _context7.next = 8;
                  break;
                }

                return _context7.abrupt("return", successResponse);

              case 8:
                return _context7.abrupt("return", null);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function saveToFavorites(_x11) {
        return _saveToFavorites.apply(this, arguments);
      }

      return saveToFavorites;
    }()
  }, {
    key: "removeFromFavorites",
    value: function () {
      var _removeFromFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(giftItemId, giftListId) {
        var _response$data5;

        var response, successResponse;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.axios.post(this.config.postfix.REMOVE_FAVORITES, {
                  giftItemId: giftItemId,
                  giftListId: giftListId,
                  locale: "en_US"
                });

              case 2:
                response = _context8.sent;
                successResponse = response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.successResponse;

                if (!successResponse) {
                  _context8.next = 8;
                  break;
                }

                return _context8.abrupt("return", {
                  successResponse: successResponse
                });

              case 8:
                return _context8.abrupt("return", null);

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function removeFromFavorites(_x12, _x13) {
        return _removeFromFavorites.apply(this, arguments);
      }

      return removeFromFavorites;
    }()
  }, {
    key: "getTarbonMenu",
    value: function () {
      var _getTarbonMenu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(widgetIdAndAPI) {
        var _responseData$data,
            _responseData$data$me,
            _this = this;

        var response, responseData;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.axios.get("https://menusnow.io/API/Widget/GetMenus?".concat(widgetIdAndAPI));

              case 2:
                response = _context9.sent;
                responseData = response.data; // menus[] > Section[] > Subsection[] ?  || Item[]

                return _context9.abrupt("return", responseData === null || responseData === void 0 ? void 0 : (_responseData$data = responseData.data) === null || _responseData$data === void 0 ? void 0 : (_responseData$data$me = _responseData$data.menus) === null || _responseData$data$me === void 0 ? void 0 : _responseData$data$me.map(function (menu) {
                  return _this.processTurbonMenu(menu);
                }));

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getTarbonMenu(_x14) {
        return _getTarbonMenu.apply(this, arguments);
      }

      return getTarbonMenu;
    }()
  }, {
    key: "processTurbonMenu",
    value: function processTurbonMenu(menu) {
      // sections -> categories
      return {
        id: menu === null || menu === void 0 ? void 0 : menu.code,
        name: "BEER",
        slug: "beer",
        imageURL: "",
        imageAltText: "",
        mobileBrowseImageURL: "",
        mobileBrowseImageAltText: "",
        legalDisclaimer: "",
        hidePrice: undefined,
        vectorImageUrl: undefined,
        longDescription: "",
        mobileAppImageURL: "",
        isToGo: false,
        menucategories: this.processTurbonMenuSection(menu.sections, "beer"),
        menu: undefined,
        isTarbonMenuCategory: true
      };
    }
    /**
     * @param preventAppendingCurrentCat used to avoid appending
     * pint-goblet-cal-270-pub-glass in breadCrumbSlug as its common for
     * most of categories. For those cateogry we need to use category name
     * of parent only.
     *
     */

  }, {
    key: "processTurbonMenuSection",
    value: function processTurbonMenuSection(sections, parentCatName) {
      var _this2 = this;

      var preventAppendingCurrentCat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return sections === null || sections === void 0 ? void 0 : sections.map(function (section) {
        var _section$items, _section$subsections;

        var currentCatSlug = preventAppendingCurrentCat ? "" : "/".concat(section === null || section === void 0 ? void 0 : section.slug);
        var parentBreadCrumbSlug = parentCatName + currentCatSlug;
        return {
          id: section.digital_display_name,
          name: section.header,
          slug: section === null || section === void 0 ? void 0 : section.slug,
          imageURL: "",
          imageAltText: "",
          mobileBrowseImageURL: "",
          mobileBrowseImageAltText: "",
          legalDisclaimer: "",
          hidePrice: undefined,
          vectorImageUrl: undefined,
          longDescription: "",
          mobileAppImageURL: "",
          isToGo: false,
          menucategories: undefined,
          menu: (section === null || section === void 0 ? void 0 : (_section$items = section.items) === null || _section$items === void 0 ? void 0 : _section$items.length) > 0 ? _this2.processTurbonMenuItems(section === null || section === void 0 ? void 0 : section.items, parentBreadCrumbSlug) : (section === null || section === void 0 ? void 0 : (_section$subsections = section.subsections) === null || _section$subsections === void 0 ? void 0 : _section$subsections.length) > 0 ? _this2.getItemsfromSubSections(section, parentBreadCrumbSlug) : undefined,
          isTarbonMenuCategory: true
        };
      });
    }
  }, {
    key: "getItemsfromSubSections",
    value: function getItemsfromSubSections(section, parentBreadCrumbSlug) {
      var _section$subsections2;

      var itemsfromSubsections = section === null || section === void 0 ? void 0 : (_section$subsections2 = section.subsections) === null || _section$subsections2 === void 0 ? void 0 : _section$subsections2.map(function (subsection) {
        return subsection === null || subsection === void 0 ? void 0 : subsection.items;
      });
      var itemsList = flatten(itemsfromSubsections);
      return this.processTurbonMenuItems(itemsList, parentBreadCrumbSlug);
    }
  }, {
    key: "processTurbonMenuItems",
    value: function processTurbonMenuItems(items, breadCrumbSlug) {
      return items === null || items === void 0 ? void 0 : items.map(function (item) {
        var _item$fields, _item$fields2, _item$fields3, _item$fields4;

        return {
          specialInfoIcons: [],
          id: item.id,
          slug: item.slug,
          imageURL: "",
          imgAltText: "",
          name: item.title,
          longDescription: item === null || item === void 0 ? void 0 : item.description,
          displayMarketPrice: false,
          price: [],
          isComplex: false,
          isDineInOnly: false,
          isAlcohol: [],
          alcoholSubClassification: "",
          greyOut: false,
          calories: null,
          nutritionalFDAMessage: "",
          mobileAppSmallImage: "",
          mobileAppLargeImage: "",
          winePairingIds: [],
          keywords: [],
          priceList: [],
          isSimpleProduct: false,
          breadCrumbSlug: breadCrumbSlug,
          fields: item !== null && item !== void 0 && item.fields ? [item === null || item === void 0 ? void 0 : (_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : _item$fields.style, "ABV ".concat(item !== null && item !== void 0 && (_item$fields2 = item.fields) !== null && _item$fields2 !== void 0 && _item$fields2.abv ? (item === null || item === void 0 ? void 0 : (_item$fields3 = item.fields) === null || _item$fields3 === void 0 ? void 0 : _item$fields3.abv) + "%" : "Varies"), item === null || item === void 0 ? void 0 : (_item$fields4 = item.fields) === null || _item$fields4 === void 0 ? void 0 : _item$fields4.origin] : undefined,
          applicableOrderTypes: null
        };
      });
    }
  }, {
    key: "getBeerMenuWidget",
    value: function () {
      var _getBeerMenuWidget = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(restaurantNumber) {
        var _response$data6;

        var response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.axios.get(this.config.postfix.GET_BEER_MENU_WIDGET);

              case 2:
                response = _context10.sent;
                return _context10.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.resourceBundleData[restaurantNumber]);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getBeerMenuWidget(_x15) {
        return _getBeerMenuWidget.apply(this, arguments);
      }

      return getBeerMenuWidget;
    }()
  }, {
    key: "parseMenuCategory",
    value: function () {
      var _parseMenuCategory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(menuCategoryList, parentCatName, parentBreadCrumbSlug, restaurantNumber) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", Promise.all(menuCategoryList.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(menuCategory) {
                    var _menuCategory$browseI, _menuCategory$browseI2, _menuCategory$mobileB, _menuCategory$mobileB2, _menuCategory$vectorI, _menuCategory$mobileA, _menuCategory$product, widgetIdAndAPI, beerListData, categoryId, imageURL, imageAltText, mobileBrowseImageURL, mobileBrowseImageAltText, vectorImageURL, longDescription, mobileAppImageURL, isToGo, categoryName, legalDisclaimer, hidePrice, menuCategories, products, subCategory;

                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _context11.prev = 0;

                            if (!(menuCategory.slug[0] === "beer" && _this3.config.getConceptCode() === "YH" && restaurantNumber)) {
                              _context11.next = 16;
                              break;
                            }

                            _context11.prev = 2;
                            _context11.next = 5;
                            return _this3.getBeerMenuWidget(restaurantNumber);

                          case 5:
                            widgetIdAndAPI = _context11.sent;

                            if (!widgetIdAndAPI) {
                              _context11.next = 11;
                              break;
                            }

                            _context11.next = 9;
                            return _this3.getTarbonMenu(widgetIdAndAPI);

                          case 9:
                            beerListData = _context11.sent;
                            return _context11.abrupt("return", beerListData[0]);

                          case 11:
                            _context11.next = 16;
                            break;

                          case 13:
                            _context11.prev = 13;
                            _context11.t0 = _context11["catch"](2);
                            return _context11.abrupt("return", {
                              id: "",
                              name: "BEER",
                              slug: "beermenu",
                              imageURL: "",
                              imageAltText: "",
                              mobileBrowseImageURL: "",
                              mobileBrowseImageAltText: "",
                              legalDisclaimer: "",
                              longDescription: "Could not load beer menu at this moment.",
                              mobileAppImageURL: "",
                              isToGo: false,
                              menucategories: [],
                              isTarbonMenuCategory: true
                            });

                          case 16:
                            categoryId = getStringVal(menuCategory.repositoryId);
                            imageURL = (_menuCategory$browseI = menuCategory.browseImage) === null || _menuCategory$browseI === void 0 ? void 0 : _menuCategory$browseI.url;
                            imageAltText = (_menuCategory$browseI2 = menuCategory.browseImage) === null || _menuCategory$browseI2 === void 0 ? void 0 : _menuCategory$browseI2.imgAltText;
                            mobileBrowseImageURL = (_menuCategory$mobileB = menuCategory.mobileBrowseImage) === null || _menuCategory$mobileB === void 0 ? void 0 : _menuCategory$mobileB.url;
                            mobileBrowseImageAltText = (_menuCategory$mobileB2 = menuCategory.mobileBrowseImage) === null || _menuCategory$mobileB2 === void 0 ? void 0 : _menuCategory$mobileB2.imgAltText;
                            vectorImageURL = (_menuCategory$vectorI = menuCategory.vectorImage) === null || _menuCategory$vectorI === void 0 ? void 0 : _menuCategory$vectorI.url;
                            longDescription = getStringVal(menuCategory.longDescription);
                            mobileAppImageURL = (_menuCategory$mobileA = menuCategory.mobileAppImage) === null || _menuCategory$mobileA === void 0 ? void 0 : _menuCategory$mobileA.url;
                            isToGo = getBooleanVal(menuCategory.categoryToGo);
                            categoryName = getStringVal(menuCategory.name);
                            legalDisclaimer = getStringVal(menuCategory.legalDisclaimer);
                            hidePrice = menuCategory.hidePrice;
                            menuCategories = menuCategory.menucategories;
                            products = (_menuCategory$product = menuCategory.products) === null || _menuCategory$product === void 0 ? void 0 : _menuCategory$product.map(function (product) {
                              try {
                                var _product$alcoholSubCl, _product$slug;

                                var id = getStringVal(product.repositoryId);
                                var smallImageUrl = getStringVal(product.smallImageUrl);
                                var imgAltText = getStringVal(product.smallImageAltText);
                                var displayName = getStringVal(product.displayName);
                                var priceStr = getStringVal(product.price);
                                var price = toFloat(priceStr);
                                var lngDescription = getStringVal(product.longDescription);
                                var description = getStringVal(product.description);
                                var displayMarketPrice = getBooleanVal(product.displayMarketPrice);
                                var istoGo = !getBooleanVal(product.isToGo);
                                var greyOut = getBooleanVal(product.greyOut);
                                var isBeverageItem = getBooleanVal(product.isBeverageItem);
                                var isBulkItem = getBooleanVal(product.isBulk);
                                var nutritionCALStr = getStringVal(product.nutritionCAL);
                                var nutritionCAL = nutritionCALStr ? nutritionCALStr.substring(0, nutritionCALStr.indexOf("cal")) : null;
                                var winePairingIds = product.winePairingIds;
                                var indicators = product.indicators;
                                var keywords = product.keywords;
                                var nutritionalFDAMessage = getStringVal(product.nutritionalFDAMessage);
                                var mobileAppSmallImage = getStringVal(product.mobileAppSmallImage);
                                var mobileAppLargeImage = getStringVal(product.mobileAppLargeImage);
                                var priceList = product.price;
                                var isAlcohol = product.isAlcohol;
                                var alcoholSubClassification = (_product$alcoholSubCl = product.alcoholSubClassification) === null || _product$alcoholSubCl === void 0 ? void 0 : _product$alcoholSubCl[0];
                                var isSimpleProduct = getStringVal(product === null || product === void 0 ? void 0 : product.isSimpleProduct) === "true";
                                return {
                                  priceList: priceList,
                                  specialInfoIcons: indicators,
                                  id: id,
                                  imageURL: smallImageUrl,
                                  imgAltText: imgAltText,
                                  name: displayName,
                                  breadCrumbSlug: (parentBreadCrumbSlug ? parentBreadCrumbSlug + "/" : "") + _this3.string_to_slug(categoryName),
                                  slug: (product === null || product === void 0 ? void 0 : (_product$slug = product.slug) === null || _product$slug === void 0 ? void 0 : _product$slug.join("/")) + "/" + _this3.string_to_slug(id),
                                  longDescription: lngDescription,
                                  displayMarketPrice: displayMarketPrice,
                                  price: price,
                                  isComplex: true,
                                  isDineInOnly: istoGo,
                                  isAlcohol: isAlcohol,
                                  alcoholSubClassification: alcoholSubClassification,
                                  greyOut: greyOut,
                                  isBeverageItem: isBeverageItem,
                                  calories: nutritionCAL,
                                  nutritionalFDAMessage: nutritionalFDAMessage,
                                  mobileAppSmallImage: mobileAppSmallImage,
                                  mobileAppLargeImage: mobileAppLargeImage,
                                  winePairingIds: winePairingIds,
                                  keywords: keywords,
                                  isSimpleProduct: isSimpleProduct,
                                  applicableOrderTypes: product === null || product === void 0 ? void 0 : product.applicableOrderTypes[0],
                                  isBulkItem: isBulkItem,
                                  displayCalorie: product === null || product === void 0 ? void 0 : product.displayCalorie,
                                  description: description
                                };
                              } catch (error) {
                                console.log("Menu Parsing Error in Product: ", error);
                                return null;
                              }
                            }).filter(function (product) {
                              return !!product;
                            });
                            subCategory = {
                              id: categoryId,
                              name: categoryName,
                              slug: _this3.string_to_slug(categoryName),
                              imageURL: imageURL,
                              imageAltText: imageAltText,
                              mobileBrowseImageURL: mobileBrowseImageURL,
                              mobileBrowseImageAltText: mobileBrowseImageAltText,
                              legalDisclaimer: legalDisclaimer,
                              hidePrice: hidePrice,
                              vectorImageUrl: vectorImageURL,
                              longDescription: longDescription,
                              mobileAppImageURL: mobileAppImageURL,
                              isToGo: isToGo,
                              menucategories: null,
                              menu: products,
                              isTarbonMenuCategory: false
                            };

                            if (!(menuCategories && menuCategories.length > 0)) {
                              _context11.next = 35;
                              break;
                            }

                            _context11.next = 34;
                            return _this3.parseMenuCategory(menuCategories, categoryName, (parentBreadCrumbSlug ? parentBreadCrumbSlug + "/" : "") + _this3.string_to_slug(categoryName));

                          case 34:
                            subCategory.menucategories = _context11.sent;

                          case 35:
                            return _context11.abrupt("return", subCategory);

                          case 38:
                            _context11.prev = 38;
                            _context11.t1 = _context11["catch"](0);
                            console.log("Menu Parsing Error in Category: ", _context11.t1);
                            return _context11.abrupt("return", null);

                          case 42:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, null, [[0, 38], [2, 13]]);
                  }));

                  return function (_x20) {
                    return _ref.apply(this, arguments);
                  };
                }()).filter(function (category) {
                  return !!category;
                })));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function parseMenuCategory(_x16, _x17, _x18, _x19) {
        return _parseMenuCategory.apply(this, arguments);
      }

      return parseMenuCategory;
    }()
  }, {
    key: "process86edItem",
    value: function process86edItem(items) {
      if (!items) return null;
      var modifirermapobject = {};
      var productMapObject = {};

      if (items !== null && items !== void 0 && items.skuIds) {
        items === null || items === void 0 ? void 0 : items.skuIds.forEach(function (skuid) {
          return Object.assign(modifirermapobject, _defineProperty({}, skuid, true));
        });
      }

      if (items !== null && items !== void 0 && items.productIds) {
        items === null || items === void 0 ? void 0 : items.productIds.forEach(function (productId) {
          return Object.assign(productMapObject, _defineProperty({}, productId, true));
        });
      }

      return _objectSpread(_objectSpread({}, items), {}, {
        modifiersMap: modifirermapobject,
        productsMap: productMapObject
      });
    }
  }, {
    key: "get86edItemIds",
    value: function () {
      var _get86edItemIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(restaurantId) {
        var _response$data7;

        var response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.axios.get(this.config.postfix.ITEM_86ED, {
                  params: {
                    restaurantId: restaurantId
                  }
                });

              case 2:
                response = _context13.sent;
                return _context13.abrupt("return", this.process86edItem(response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.successResponse));

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function get86edItemIds(_x21) {
        return _get86edItemIds.apply(this, arguments);
      }

      return get86edItemIds;
    }()
  }, {
    key: "getDayPartInfo",
    value: function () {
      var _getDayPartInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(restaurantId) {
        var _response$data8;

        var response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.axios.get(this.config.postfix.MENU_DAY_PART_API, {
                  params: {
                    restaurantId: restaurantId
                  }
                });

              case 2:
                response = _context14.sent;
                return _context14.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.successResponse);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getDayPartInfo(_x22) {
        return _getDayPartInfo.apply(this, arguments);
      }

      return getDayPartInfo;
    }()
  }, {
    key: "string_to_slug",
    value: function string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim

      str = str.toLowerCase(); // remove accents, swap ñ for n, etc

      var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaeeeeiiiioooouuuunc------";

      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, "") // remove invalid chars
      .replace(/\s+/g, "-") // collapse whitespace and replace by -
      .replace(/-+/g, "-"); // collapse dashes

      return str;
    }
  }]);

  return Menu;
}(); //CSK - Lemon Pepper Chicken - prod7020033
//CSK - Original Burger - prod7020200
//CSK - cat3850006
// CSK - Rest Id - 20800004


export { Menu as default };